<template>
	<div class="app-popup-actions">
		<div
			v-if="actions.length"
			class="actions"
		>
			<ao-icon-btn
				v-for="action in actions"
				custom="popupActionCustomBtn"
				:iconName="action.icon"
				@click="$emit('action', action.name)"
			/>
		</div>
		<!-- <div v-else>
			<ao-btn
				variant="flat"
				color="primary"
				@click="$emit('click')"
				>Действие</ao-btn
			>
		</div> -->
	</div>
</template>

<script>
export default {
	name: 'PopupActions',
	props: {
		actions: {
			type: Array,
			default: () => [
				{ name: 'Edit', icon: 'pen' },
				{ name: 'copy', icon: 'slide' },
			],
		},
	},
}
</script>

<style lang="scss">
.app-popup-actions {

	.actions {
		display: flex;
		align-items: center;
		gap: 8px;

		color: #576674;
		font-size: 12px;
	}

}
</style>
